import { setBit } from "../../../helpers/binary-helpers.js";
export function getSetSubOperations(cpu) {
    const { registers, memory } = cpu;
    // ****************R
    // * Set b, A
    // ****************
    function getSetBAByteDefinition(bitPosition, registerCode) {
        return (0b11 << 6) + (bitPosition << 3) + registerCode;
    }
    cpu.registers.baseRegisters.forEach(register => {
        for (let bitPosition = 0; bitPosition < 8; bitPosition++) {
            cpu.addCbOperation({
                byteDefinition: getSetBAByteDefinition(bitPosition, register.code),
                instruction: `SET ${bitPosition}, ${register.name}`,
                cycleTime: 8,
                byteLength: 2,
                execute() {
                    register.value = setBit(register.value, bitPosition, 1);
                }
            });
        }
    });
    // ****************
    // * Set b, (HL)
    // ****************
    function getSetHLByteDefinition(bitPosition) {
        return (0b11 << 6) + (bitPosition << 3) + 0b110;
    }
    for (let bitPosition = 0; bitPosition < 8; bitPosition++) {
        cpu.addCbOperation({
            byteDefinition: getSetHLByteDefinition(bitPosition),
            instruction: `SET ${bitPosition}, (HL)`,
            cycleTime: 12,
            byteLength: 2,
            execute() {
                const value = memory.readByte(registers.HL.value);
                const bitSet = setBit(value, bitPosition, 1);
                memory.writeByte(registers.HL.value, bitSet);
            }
        });
    }
}
//# sourceMappingURL=set-operations.js.map